import { render, staticRenderFns } from "./MessagesPreview.vue?vue&type=template&id=3315e2e2&scoped=true"
import script from "./MessagesPreview.vue?vue&type=script&lang=js"
export * from "./MessagesPreview.vue?vue&type=script&lang=js"
import style0 from "./MessagesPreview.vue?vue&type=style&index=0&id=3315e2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3315e2e2",
  null
  
)

export default component.exports